import { Grid, Switch } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import Campo from "../Campo";
import { DURACION_MAXIMA_EVENTO_DIAS, ahoraInput, cruzaMedianoche, duracionTexto } from "../../utils";

export default function PasoDatos({ form, setField, errores, inicioBloqueado, soloLectura, finEditable }) {
  const duracion = duracionTexto(form.inicio, form.fin);
  // Al extender el cierre de un finalizado solo el Fin se edita, sin tope de días.
  const finBloqueado = soloLectura && !finEditable;
  // El mínimo se recalcula al enfocar: la pantalla puede quedar abierta un rato.
  const [minFin, setMinFin] = useState(ahoraInput);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Campo id="evento-nombre" label="Nombre del evento" requerido error={errores.nombre}>
          <SoftInput id="evento-nombre" placeholder="Ej.: CONAFO 2026" value={form.nombre}
            onChange={(e) => setField("nombre", e.target.value)} error={Boolean(errores.nombre)} disabled={soloLectura}
            inputProps={{ maxLength: 255, disabled: soloLectura }} autoFocus />
        </Campo>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Campo id="evento-inicio" label="Inicio" requerido error={errores.inicio}
          ayuda={inicioBloqueado && !soloLectura ? "Fijo: el evento ya comenzó o tiene ventas." : null}>
          <SoftInput id="evento-inicio" type="datetime-local" value={form.inicio} disabled={inicioBloqueado || soloLectura}
            onChange={(e) => setField("inicio", e.target.value)} error={Boolean(errores.inicio)}
            inputProps={{ disabled: inicioBloqueado || soloLectura }} />
        </Campo>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Campo id="evento-fin" label="Fin" requerido error={errores.fin}
          ayuda={errores.fin || !duracion ? null
            : finEditable ? `Duración: ${duracion}. Nuevo cierre posterior a ahora, sin límite de duración.`
              : `Duración: ${duracion} (máximo ${DURACION_MAXIMA_EVENTO_DIAS} días)`}>
          <SoftInput id="evento-fin" type="datetime-local" value={form.fin} disabled={finBloqueado}
            onFocus={finEditable ? () => setMinFin(ahoraInput()) : undefined}
            onChange={(e) => setField("fin", e.target.value)} error={Boolean(errores.fin)}
            inputProps={{ disabled: finBloqueado, ...(finEditable ? { min: minFin } : {}) }} />
        </Campo>
      </Grid>
      {inicioBloqueado && !soloLectura && (
        <Grid item xs={12}>
          <SoftTypography variant="caption" color="secondary">
            Como el evento ya comenzó o tiene ventas, el inicio no se puede cambiar. El fin puede adelantarse o
            extenderse, sin quedar antes de ahora ni de la última venta. Precios, productos, medios de pago, impresora y
            bloqueos sí se pueden cambiar y aplican a las ventas siguientes.
          </SoftTypography>
        </Grid>
      )}
      {cruzaMedianoche(form.inicio, form.fin) && (
        <Grid item xs={12}>
          <SoftTypography variant="caption" color="secondary">
            El punto de venta y los bloqueos también quedan activos durante la noche. Para limitarlos al horario de cada
            jornada, cree un evento por día.
          </SoftTypography>
        </Grid>
      )}
      <Grid item xs={12}>
        <SoftBox display="flex" alignItems="center" gap={1}>
          <Switch checked={form.activo} disabled={soloLectura} onChange={(_, value) => setField("activo", value)} inputProps={{ "aria-label": "Evento activo" }} />
          <SoftTypography variant="button" fontWeight="bold">{form.activo ? "Evento activo" : "Evento desactivado"}</SoftTypography>
        </SoftBox>
      </Grid>
    </Grid>
  );
}

PasoDatos.propTypes = {
  form: PropTypes.object.isRequired,
  setField: PropTypes.func.isRequired,
  errores: PropTypes.object.isRequired,
  inicioBloqueado: PropTypes.bool,
  soloLectura: PropTypes.bool,
  finEditable: PropTypes.bool,
};

PasoDatos.defaultProps = { inicioBloqueado: false, soloLectura: false, finEditable: false };
